const Star = ({ fontSize = "1rem", opacity, style = {} }) => {
  const id = Math.random().toString();

  return (
    <span
      id={id}
      style={{
        opacity: opacity,
        fontSize: fontSize,
        ...style,
      }}
      role="img"
      aria-label={""}
      aria-hidden={"true"}
    >
      ⭐
    </span>
  );
};
/* 
return (
  <svg
    style={{
      width: fontSize,
      height: fontSize,
      ...style,
    }}
    width="200"
    height="200"
    viewBox="0 0 200 200"
    id={id}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath={`url(#clip0_223_2_${id})`}>
      <path
        d="M161.841 191.155L151.049 125.202L100.099 108.099L161.841 191.155Z"
        fill={color || "#F3C15F"}
      />
      <path
        d="M100.099 160.881L161.841 191.155L100.099 108.099V160.881Z"
        fill={color || `url(#paint0_radial_223_2_${id})`}
      />
      <path
        d="M38.3564 191.155L100.099 160.881V108.099L38.3564 191.155Z"
        fill={color || "#F8D951"}
      />
      <path
        d="M49.1491 125.202L38.3564 191.155L100.099 108.099L49.1491 125.202Z"
        fill={color || "#FFEB94"}
      />
      <path
        d="M0.197754 77.9587L49.1492 125.201L100.099 108.099L0.197754 77.9587Z"
        fill={color || `url(#paint1_radial_223_2_${id})`}
      />
      <path
        d="M68.6102 67.4718L0.197754 77.959L100.099 108.099L68.6102 67.4718Z"
        fill={color || `url(#paint2_radial_223_2_${id})`}
      />
      <path
        d="M100.099 8L68.6104 67.4717L100.099 108.099V8Z"
        fill={color || `url(#paint3_radial_223_2_${id})`}
      />
      <path
        d="M131.588 67.4717L100.099 8V108.099L131.588 67.4717Z"
        fill={color || `url(#paint4_radial_223_2_${id})`}
      />
      <path
        d="M200 77.959L131.588 67.4718L100.099 108.099L200 77.959Z"
        fill={color || `url(#paint5_radial_223_2_${id})`}
      />
      <path
        d="M151.049 125.201L200 77.9587L100.099 108.099L151.049 125.201Z"
        fill={color || `url(#paint6_radial_223_2_${id})`}
      />
      <path
        d="M199.58 78.44L151.384 124.782L161.888 190.897L140.262 121.693L199.58 78.44L124.815 75.9685L100.099 8.61792L74.7653 75.9685L0.617895 77.8221L2.56168 79.7167L59.3179 121.693L38.3095 190.897L99.4811 150.116L161.271 190.897L100.099 160.62L38.3095 190.897L49.4316 125.4L2.56168 79.7167L0.617895 77.8221L68.5863 67.3179L100.099 8.61792L131.612 67.3179L199.58 78.44Z"
        fill={color || `url(#paint7_linear_223_2_${id})`}
      />
    </g>
    <defs>
      <radialGradient
        id={`paint0_radial_223_2_${id}`}
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(100.099 108.099) rotate(56.8368) scale(74.5505 55.4196)"
      >
        <stop stopColor="#C89B44" />
        <stop offset="0.723958" stopColor="#C89B44" />
        <stop offset="1" stopColor="#D8B062" />
        <stop offset="1" stopColor="#E1B359" />
      </radialGradient>
      <radialGradient
        id={`paint1_radial_223_2_${id}`}
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(100.099 108.099) rotate(-162.474) scale(98.4917 208.274)"
      >
        <stop stopColor="#EBB700" />
        <stop offset="0.380208" stopColor="#FBCD24" />
        <stop offset="1" stopColor="#FFE389" />
      </radialGradient>
      <radialGradient
        id={`paint2_radial_223_2_${id}`}
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(64.8788 71.6432) rotate(105.524) scale(23.0865 56.7688)"
      >
        <stop stopColor="#FFFAE7" />
        <stop offset="1" stopColor="#FFEAB3" />
      </radialGradient>
      <radialGradient
        id={`paint3_radial_223_2_${id}`}
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(72.9115 64.8463) rotate(-80.8698) scale(70.0923 53.1734)"
      >
        <stop stopColor="#FFEFB0" />
        <stop offset="0.5625" stopColor="#FFF2C1" />
      </radialGradient>
      <radialGradient
        id={`paint4_radial_223_2_${id}`}
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(100.099 108.099) rotate(-64.9574) scale(83.205 49.5268)"
      >
        <stop stopColor="#FFCB3F" />
        <stop offset="0.651042" stopColor="#FFEC98" />
        <stop offset="1" stopColor="#FFF6C8" />
      </radialGradient>
      <radialGradient
        id={`paint5_radial_223_2_${id}`}
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(100.099 105.01) rotate(-15.1858) scale(89.6352 220.41)"
      >
        <stop stopColor="#FFE282" />
        <stop offset="1" stopColor="#FFF4C9" />
      </radialGradient>
      <radialGradient
        id={`paint6_radial_223_2_${id}`}
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(100.099 107.481) rotate(-14.1423) scale(80.9254 171.128)"
      >
        <stop stopColor="#D0940F" />
        <stop offset="1" stopColor="#FFD226" />
      </radialGradient>
      <linearGradient
        id={`paint7_linear_223_2_${id}`}
        x1="165.596"
        y1="197.076"
        x2="22.8621"
        y2="9.23581"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#995C00" />
        <stop offset="1" stopColor="#FF9900" stopOpacity="0.2" />
      </linearGradient>
      <clipPath id={`clip0_223_2_${id}`}>
        <rect width="200" height="200" fill="white" />
      </clipPath>
    </defs>
  </svg>
  
);*/

export default Star;
